function d({
  props: n,
  states: u,
  muiFormControl: r
}) {
  return u.reduce((e, f) => (e[f] = n[f], r && typeof n[f] > "u" && (e[f] = r[f]), e), {});
}
export {
  d as default
};
//# sourceMappingURL=formControlState.mjs.map
